import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addProduct,
  selectCartProducts,
  selectCartTotal,
  removeProduct,
  fetchProducts,
  updateProductPackage,
  removeFromRentCart,
} from "../../redux/Slices/cartSlice";
import { MdAdd, MdRemove, MdOutlineShoppingBag, MdDelete } from "react-icons/md";
import { CiDiscount1 } from "react-icons/ci";
import { TfiTimer } from "react-icons/tfi";
import axiosConfig from "../../Service/axiosConfig";
import { Products } from "../Products";
import { BsFileTextFill } from "react-icons/bs";
import { RiMotorbikeFill } from "react-icons/ri";
import { TbArrowBigUpLines } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import Modal from "react-bootstrap/Modal";
import { TbCircleArrowUpRightFilled } from "react-icons/tb";
import "./viewcart.css"
const ViewCart = ({
  handleClose,
  setOrders,
  Order,
  setTotalAmount,
  orderAddress,
  productAmount,
  travelTime,
  setMiniPopUp,
  setApiDeliveryCharge,
}) => {
  const products = useSelector(selectCartProducts);
  const rentCart = useSelector((state) => state.cart.rentCart || []);
  const total = useSelector(selectCartTotal);
  const dispatch = useDispatch();
  let Navigate = useNavigate();
  let ProductData = [];
  const [modalShow, setModalShow] = React.useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [waiverData, setWaiverData] = useState({});
  const [deliveryData, setDeliveryData] = useState({});
  const [packingData, setPackingData] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [packagesMap, setPackagesMap] = useState({});
  const [productDetailsMap, setProductDetailsMap] = useState({});
  const [apiDeliveryCharges, setApiDeliveryCharges] = useState(null);
  const [apiDeliveryDetails, setApiDeliveryDetails] = useState([]);

  useEffect(() => {
    if (!products || products.length === 0) return;

    products.forEach((product) => {
      const isRental = product.cart_type === "rent" || (product.sale_or_rent && product.sale_or_rent.toLowerCase().includes("rent"));

      if (isRental && packagesMap[product.id] === undefined) {
        // Prevent duplicate calls immediately by setting to null initially
        setPackagesMap((prev) => ({ ...prev, [product.id]: null }));

        axiosConfig
          .get(`/catlog/variant-price-packages/?product_variant=${product.id}&active=true`)
          .then((res) => {
            if (res.data && Array.isArray(res.data.results) && res.data.results.length > 0) {
              setPackagesMap((prev) => ({
                ...prev,
                [product.id]: res.data.results,
              }));

              if (!product.selectedPackage) {
                dispatch(updateProductPackage({ productId: product.id, packageData: res.data.results[0] }));
              }
            } else {
              setPackagesMap((prev) => ({ ...prev, [product.id]: [] }));
            }
          })
          .catch((err) => {
            console.error("Failed to fetch packages for", product.id, err);
            setPackagesMap((prev) => ({ ...prev, [product.id]: [] }));
          });
      }
    });
  }, [products, packagesMap, dispatch]);

  // Fetch latest product details from API for each cart item
  useEffect(() => {
    if (!products || products.length === 0) return;
    const storeId = localStorage.getItem("storeId") || 2;

    products.forEach((product) => {
      if (product.id && !productDetailsMap[product.id]) {
        setProductDetailsMap((prev) => ({ ...prev, [product.id]: "loading" }));
        axiosConfig
          .get(`/catlog/products/${product.id}/?store=${storeId}`)
          .then((res) => {
            if (res.data) {
              setProductDetailsMap((prev) => ({ ...prev, [product.id]: res.data }));
            }
          })
          .catch(() => {
            setProductDetailsMap((prev) => ({ ...prev, [product.id]: null }));
          });
      }
    });
  }, [products]);

  useEffect(() => {
    const fetchDeliveryCharges = async () => {
      const address_id = (orderAddress && orderAddress.id) || localStorage.getItem("address_id");
      if (!address_id || products.length === 0) return;

      try {
        const payload = {
          items: products.map((p) => {
            const type = p.cart_type || (p.sale_or_rent && p.sale_or_rent.toLowerCase().includes("sale") ? "sale" : "rent");
            return {
              cart_type: type,
              quantity: p.quantity,
              [type === "sale" ? "sale_address_id" : "rental_address_id"]: parseInt(address_id)
            };
          })
        };
        const res = await axiosConfig.post("/accounts/deliverycharges/", payload);
        if (res.data && res.data.details) {
          let totalDelivery = 0;
          res.data.details.forEach(item => {
            totalDelivery += (item.delivery_charges || 0);
          });
          setApiDeliveryCharges(totalDelivery);
          setApiDeliveryCharge(totalDelivery);
          // setTotalAmount({
          //   Total_amount: productAmount.totalAmount + totalDelivery,
          // });
          setApiDeliveryDetails(res.data.details);
          
        }
      } catch (error) {
        console.error("Error fetching delivery charges", error);
      }
    };

    fetchDeliveryCharges();
  }, [products, orderAddress]);
  // const handleRemove = (productId, quantity) => {
  //   dispatch(removeProduct({ productId, quantity }));
  // };
  const handleRemove = (productId, quantity) => {
    const product = products.find((p) => p.id === productId);
    if (!product) return;

    const minQty = product.min_qty || 1;
    const currentQty = product.quantity;

    // If current quantity equals minimum quantity, remove all
    if (currentQty === minQty) {
      dispatch(removeProduct({ productId, quantity: currentQty }));
    } else {
      // Otherwise remove just 1
      dispatch(removeProduct({ productId, quantity: 1 }));
    }
  };
  const showMaxQuantityMessage = () => {
    setShowMessage(true)
    setTimeout(() => {
      setShowMessage(false)
    }, 2000);
  }
  const handleShopping = () => {
    Navigate("/");
    handleClose();
  };
  const handleShowModal = (title) => {
    setMiniPopUp(true);
    setModalTitle(title);
    setModalShow(true);
  };

  const addToCart = (product) => {
    dispatch(addProduct({ product: product, quantity: 1 }));
    console.log("added");
  };

  const HandleMiniPopUpClose = () => {
    setMiniPopUp(false);
    setModalShow(false);
  };
  useEffect(() => {
    console.log(productAmount);
    products.forEach((res) => {
      ProductData.push({
        id: res.id,
        min_qty: res.quantity,
      });
    });
    setOrders && setOrders({ ...Order, products: ProductData });
    // const serializedState = JSON.stringify(products);
    // products.length > 0 && localStorage.setItem('state', serializedState)
  }, [products]);
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const MyCenteredModal = (props) => {
    return (
      <Modal className="template-temp2"
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={HandleMiniPopUpClose}
        show={modalShow}
      >
        <Modal.Body className="template-temp2 modal-body-viewCart">
          {modalTitle === "Packing Charges" ? (
            <>
              <h2>Packing Charges</h2>
              {packingData.length > 0 &&
                packingData.map((p) => {
                  return (
                    <p>
                      {Math.round(p.from_kg)}Kg to {Math.round(p.to_kg)}Kg
                      charges ${parseFloat(p.charges).toFixed(2)}
                    </p>
                  );
                })}
              {waiverData && (
                <p>
                  $0 for order value above{" "}
                  {waiverData.schedule_packing_waier_order_value_above}
                </p>
              )}
            </>
          ) : (
            <>
              {console.log(
                deliveryData.schedule_delivery_charges,
                "deliveryData"
              )}
              <h2>Delivery Charges</h2>
              {apiDeliveryDetails && apiDeliveryDetails.length > 0 ? (
                <>
                  <p>Itemized Delivery Charges:</p>
                  <ul>
                    {apiDeliveryDetails.map((d, index) => (
                      <li key={index}>
                        <p>
                          {d.cart_type} (Qty: {d.quantity}): ${parseFloat(d.delivery_charges || 0).toFixed(2)}
                          {d.distance_km ? ` (${d.distance_km} km)` : ""}
                        </p>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                deliveryData.length > 0 &&
                (localStorage.getItem("delivery_type") &&
                  localStorage.getItem("delivery_type") === "Schedule" ? (
                  <>
                    <p>
                      Schedule delivery charges :
                    </p>
                    <ul>
                      {deliveryData.map(d => {
                        return (
                          <li>
                            <p>
                              From ${parseFloat(d.schedule_delivery_charges_order_value_from || 0).toFixed(2)} to ${parseFloat(d.schedule_delivery_charges_order_value_to || 0).toFixed(2)} - ${parseFloat(d.schedule_delivery_charges || 0).toFixed(2)}
                            </p>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <>
                    <p>
                      Express delivery charges :
                    </p>
                    <ul>
                      {deliveryData.map(d => {
                        return (
                          <li>
                            <p>
                              From ${parseFloat(d.express_delivery_charges_order_value_from || 0).toFixed(2)} to ${parseFloat(d.express_delivery_charges_order_value_to || 0).toFixed(2)} - ${parseFloat(d.express_delivery_charges || 0).toFixed(2)}
                            </p>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                )))}
              {Order.spike_percentage > 0 && (
                <p>
                  {Order.spike_percentage}% spike {Order.spike_comment}
                </p>
              )}
              {waiverData &&
                (localStorage.getItem("delivery_type") === "Schedule" ? (
                  <p>
                    $0 for order value above{" "}
                    {waiverData.schedule_delivery_waier_order_value_above}
                  </p>
                ) : (
                  <p>
                    $0 for order value above{" "}
                    {waiverData.express_delivery_waier_order_value_above}
                  </p>
                ))}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="template-temp2 modal-footer-viewCart">
          <span className="modal-footer-text" onClick={HandleMiniPopUpClose}>
            <b>Sounds good</b>
          </span>
        </Modal.Footer>
      </Modal>
    );
  };
  console.log(Order, "order");
  return (
    <div>
      {products.length === 0 && rentCart.length === 0 ? (
        <div className="Empty-cart">
          <div>
            <img
              className="empty-img"
              src={require("../Navbar/images/emp_empty_cart.png")}
              alt="emp"
            />
          </div>
          <p className="p-delivery-time">
            You don't have any items in your cart
          </p>
          <p className="message-cart">
            Your favourite items are just a click away
          </p>
          <button
            type="button"
            className="btn--link"
            onClick={() => handleShopping()}
          >
            Start Shopping
          </button>
          {/* <p className="p-qty">{cart.products.length} items</p> */}
        </div>
      ) : (
        <>
          <div className="bill-details py-2">
            <div className="cart-timer">
              <div className="cart-timer-icon">
                <TfiTimer size={24} />
              </div>
              <div>
                {localStorage.getItem("site_data") &&
                  JSON.parse(localStorage.getItem("site_data"))
                    .ecommerce_type !== "Conventional" && (
                    <p className="p-delivery-time">
                      {travelTime
                        ? `Delivery in  ${travelTime ? travelTime : 10} minutes`
                        : "Delivery to"}
                    </p>
                  )}
                <p className="p-qty">Shipment of {products.length + rentCart.length} items</p>
              </div>
            </div>
            {products.map((product) => {
              // Merge with fresh API data if available, using correct price field based on cart_type
              const apiDetails = productDetailsMap[product.id];
              let mergedProduct = product;

              if (apiDetails && typeof apiDetails === 'object') {
                const isRent = product.cart_type === "rent" ||
                  (product.sale_or_rent && product.sale_or_rent.toLowerCase().includes("rent"));

                // Compute effective price from API using the same logic as Product.jsx
                const effectivePrice = isRent
                  ? (apiDetails.prices?.rental_price || apiDetails.rental_price || apiDetails.prices?.sale_price || apiDetails.sale_price || apiDetails.price || product.price)
                  : (apiDetails.prices?.sale_price || apiDetails.sale_price || apiDetails.price || product.price);

                const effectiveOfferPrice = isRent
                  ? (apiDetails.prices?.rental_offer_price || apiDetails.rental_offer_price || effectivePrice)
                  : (apiDetails.prices?.sale_offer_price || apiDetails.sale_offer_price || apiDetails.offer_price || null);

                mergedProduct = {
                  ...product,
                  name: apiDetails.name || product.name,
                  price: effectivePrice,
                  offer_price: (effectiveOfferPrice && effectiveOfferPrice > 0 && effectiveOfferPrice !== effectivePrice)
                    ? effectiveOfferPrice
                    : null,
                  image: apiDetails.image?.image ||
                    (typeof apiDetails.image === 'string' ? apiDetails.image : product.image),
                  max_qty: apiDetails.max_qty ?? product.max_qty,
                };
              }

              return (
                <div className="productItem" key={product.id}>
                  <div className="row">
                    <div className="col-2">
                      <img
                        src={mergedProduct.image}
                        className="cart-display-img"
                      />
                    </div>
                    <div className="col-6">
                      <p>{mergedProduct.name}</p>
                      {mergedProduct.weight_in_kg && mergedProduct.weight_in_kg > 0 ? (
                        <>
                          <p>{product.weight_in_kg}</p>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="d-flex">
                        {product.selectedPackage ? (
                          <>
                            <p className="cart-item-price">
                              ${((product.selectedPackage.offer_price > 0 ? product.selectedPackage.offer_price : product.selectedPackage.price) * product.quantity).toFixed(2)}
                            </p>
                            {product.selectedPackage.offer_price > 0 && (
                              <p className="produc-price ms-2">${(product.selectedPackage.price * product.quantity).toFixed(2)}</p>
                            )}
                          </>
                        ) : (
                          mergedProduct.offer_price && mergedProduct.offer_price > 0 ? (
                            <>
                              <p className="cart-item-price">
                                ${(mergedProduct.offer_price * product.quantity).toFixed(2)}
                              </p>
                              <p
                                className={
                                  mergedProduct.offer_price
                                    ? "produc-price ms-2"
                                    : "cart-item-price"
                                }
                              >
                                ${(mergedProduct.price * product.quantity).toFixed(2)}
                              </p>
                            </>
                          ) : (
                            <p className="cart-item-price">${(mergedProduct.price * product.quantity).toFixed(2)}</p>
                          )
                        )}
                      </div>
                      {packagesMap[product.id] && packagesMap[product.id].length > 0 && (
                        <div className="mt-2" style={{ maxWidth: "200px" }}>
                          <select
                            className="form-select form-select-sm"
                            value={product.selectedPackage ? product.selectedPackage.id : ""}
                            onChange={(e) => {
                              const pkgId = e.target.value;
                              const pkg = packagesMap[product.id].find(p => p.id.toString() === pkgId) || null;
                              dispatch(updateProductPackage({ productId: product.id, packageData: pkg }));
                            }}
                          >
                            <option value="">Standard Price</option>
                            {packagesMap[product.id].map(pkg => (
                              <option key={pkg.id} value={pkg.id}>
                                {pkg.package_name} - ${pkg.offer_price > 0 ? pkg.offer_price : pkg.price}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <div className="p-btn">
                        <div className="btn btn-cart btn-cart-added">
                          <button
                            className="btn-minus"
                            onClick={() => handleRemove(product.id, 1)}
                          >
                            <div className="custom-minus"></div>
                          </button>
                          <div className="qty">{product.quantity}</div>
                          <button
                            className="btn-minus"
                            disabled={mergedProduct.max_qty === product.quantity}
                            onClick={() => product.quantity === mergedProduct.max_qty ? showMaxQuantityMessage() : addToCart(product)}
                          >
                            <div className="custom-plus"></div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <td>{product.name}</td>
                  <td>${product.price.toFixed(2)}</td>
                  <td>{product.quantity}</td>
                  <td>${(product.price * product.quantity).toFixed(2)}</td>
                  <td>
                    <button onClick={() => handleRemove(product.id, product.quantity)}>Remove</button>
                  </td> */}
                </div>
              );
            })}

            {rentCart.map((rentItem) => {
              let durationText = "-";
              const count = Number(rentItem.duration ?? rentItem.selectedPackage?.duration_value ?? 1) || 1;
              const planKey = (rentItem.rentalPlan || rentItem.selectedPackage?.package_name || "Daily").toLowerCase();
              let unit = "day";
              let plural = "days";
              if (planKey.includes("week")) { unit = "week"; plural = "weeks"; }
              else if (planKey.includes("month")) { unit = "month"; plural = "months"; }
              else if (planKey.includes("annu") || planKey.includes("year")) { unit = "year"; plural = "years"; }
              durationText = `${count} ${count === 1 ? unit : plural}`;

              return (
                <div className="productItem" key={rentItem.cartItemId}>
                  <div className="row">
                    <div className="col-2">
                      <img
                        src={rentItem.image}
                        className="cart-display-img"
                        alt={rentItem.name}
                      />
                    </div>
                    <div className="col-6">
                      <p>{rentItem.name}</p>
                      <p style={{ fontSize: "12px", color: "gray" }}>Rental Plan: {rentItem.rentalPlan}</p>
                      <p style={{ fontSize: "12px", color: "gray" }}>Start Date: {rentItem.fromDate}</p>
                      <p style={{ fontSize: "12px", color: "gray" }}>Duration: {durationText}</p>
                      <div className="d-flex">
                        <p className="cart-item-price">
                          ${(rentItem.offerPrice * rentItem.qty).toFixed(2)} <span className="produc-price-2">${rentItem?.rentalCharges?.base_cost}</span>
                        </p>
                        {rentItem.price > rentItem.offerPrice && (
                          <p className="produc-price ms-2">${(rentItem.price * rentItem.qty).toFixed(2)}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="p-btn" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div className="btn btn-cart btn-cart-added" style={{ padding: "0" }}>
                          <button
                            className="btn-minus"
                            onClick={() => dispatch(removeFromRentCart(rentItem.cartItemId))}
                            style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                          >
                            <MdDelete size={20} className="md-delete" />
                          </button>
                        </div>
                        <div style={{ fontSize: "15px", fontWeight: "bold", color: "gray", whiteSpace: "nowrap", marginTop: "4px" }}>
                          Qty: {rentItem.qty}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {console.log(products, rentCart, "products and rentCart")}
          {(products.length > 0 || rentCart.length > 0) && (
            <div className="bill-details py-2 m-1">
              {products.length > 0 && (
                <Products
                  id={products[0].id}
                  products_for="Before you checkout"
                  filter_id={products[0].subcategory}
                  insideCart={true}
                />
              )}
            </div>
          )}
          {/* <div className="bill-details f_12_500 f_roboto py-2">
            <div className="bill-head">Bill details</div>
            <div className="rowBetweenCenter mb-2">
              <div className="rowCenter">
                <BsFileTextFill size={14} style={{ marginRight: "6px" }} /> Item
                total
                {productAmount.discount + productAmount.PackingCharges > 0 && (
                  <div className="saved">
                    saved ${parseFloat(productAmount.discount).toFixed(2)}
                  </div>
                )}
              </div>
              {productAmount.discount > 0 ? (
                <div>
                  <strike>${parseFloat(productAmount.mrp).toFixed(2)}</strike>
                  <span>
                    {" "}
                    $
                    {parseFloat(
                      productAmount.mrp - productAmount.discount
                    ).toFixed(2)}
                  </span>
                </div>
              ) : (
                <div>${parseFloat(productAmount.mrp).toFixed(2)}</div>
              )}
            </div>
            {console.log(orderAddress, "inside view cart")}
            {orderAddress &&
            <>
              {
                <div className="rowBetweenCenter">
                  <div className="rowCenter">
                    <RiMotorbikeFill size={14} style={{ marginRight: "6px" }} />{" "}
                    Delivery charges
                    <HiOutlineInformationCircle
                      className="icon-info"
                      onClick={() => {
                        handleShowModal("Delivery Charges");
                      }}
                      size={40}
                    />
                    <MyCenteredModal
                      show={modalShow}
                      onHide={() => setModalShow(false)}
                    />
                  </div>
                  <div>
                    <div>
                      ${parseFloat(apiDeliveryCharges !== null ? apiDeliveryCharges : (productAmount.deliveryCharges || 0)).toFixed(2)}
                    </div>
                  </div>
                </div>
              }
              <div className="rowBetweenCenter">
                <div className="rowCenter">
                  <MdOutlineShoppingBag
                    size={14}
                    style={{ marginRight: "6px" }}
                  />{" "}
                  Packing charges
                  <HiOutlineInformationCircle
                    className="icon-info"
                    onClick={() => {
                      handleShowModal("Packing Charges");
                    }}
                    size={40}
                  />
                </div>
                <div>
                  <div>
                    ${parseFloat(productAmount.PackingCharges).toFixed(2)}
                  </div>
                </div>
              </div>
            </>
         } 
            <div className="grand-total">
              <div className="f_13_700">Grand total</div>
              <div className="grand-total">
                ${(apiDeliveryCharges !== null ?
                  (productAmount.totalAmount - (productAmount.deliveryCharges || 0) + apiDeliveryCharges) :
                  productAmount.totalAmount).toFixed(2)}
                  ${productAmount.totalAmount}
              </div>
            </div>
            <div className="cuppons-aply">
              <CiDiscount1 size={20} className="me-2" />
              Coupons are only applicable on the Opoto app
            </div>
          </div> */}
          {/* <div className="bill-details cancellation-policy">
            <div className="CancellationPolicy">Cancellation Policy</div>
            <div className="CancellationPolicy-content">
              Orders cannot be cancelled once packed for delivery. In case of
              unexpected delays, a refund will be provided, if applicable.
            </div>
          </div> */}
        </>
      )}
      {showMessage && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '12px 20px',
            borderRadius: '8px',
            zIndex: 9999,
            animation: 'fadeInOut 2s ease-in-out'
          }}
        >
          Sorry, you've reached the maximum quantity for this item.
        </div>
      )}
    </div>

  );
};
export { ViewCart };
